const FILE_EXTENSION = /\.[a-z0-9]+$/i;
const NON_HTTP_SCHEME = /^(mailto:|tel:|phone:|#)/i;

/** Domaines publics du site (tous pays). `b2b.pneumaclic.*` reste externe. */
const SITE_HOST = /^(www\.)?pneumaclic\.(com|fr|be|lu|de|es|it)$/i;

function isInternalHost(hostname: string, siteUrl?: string): boolean {
  if (SITE_HOST.test(hostname)) return true;
  if (!siteUrl) return false;
  try {
    return new URL(siteUrl).hostname === hostname;
  } catch {
    return false;
  }
}

/** Ajoute un `/` final à un chemin relatif (avant ?query / #hash). Ignore les fichiers. */
export function withTrailingSlash(path: string): string {
  if (!path || NON_HTTP_SCHEME.test(path) || /^https?:/i.test(path)) return path;

  const match = path.match(/^([^?#]*)(.*)$/);
  const [pathname, suffix] = [match?.[1] ?? '', match?.[2] ?? ''];
  const lastSegment = pathname.split('/').pop() ?? '';

  if (pathname.endsWith('/') || FILE_EXTENSION.test(lastSegment)) return path;
  return `${pathname}/${suffix}`;
}

/** Comme withTrailingSlash, mais accepte aussi une URL absolue du site (tous TLD confondus). */
export function withTrailingSlashIfInternal(url: string, siteUrl?: string): string {
  if (!/^https?:/i.test(url)) return withTrailingSlash(url);

  let target: URL;
  try {
    target = new URL(url);
  } catch {
    return url;
  }
  if (!isInternalHost(target.hostname, siteUrl)) return url;

  target.pathname = withTrailingSlash(target.pathname);
  return target.toString();
}

/** Retire le `/` final (sauf pour la racine) — pour comparer des pathnames. */
export function stripTrailingSlash(path: string): string {
  return path.replace(/(.)\/+$/, '$1');
}
